var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.00006C3 4.34321 4.34315 3.00006 6 3.00006H8V5H6C5.44772 5 5 5.44772 5 6V8H3V6.00006Z",
    fill: "#7B61FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5V3.00006H18C19.6569 3.00006 21 4.34321 21 6.00006V8H19V6C19 5.44772 18.5523 5 18 5H16Z",
    fill: "#7B61FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16V18C19 18.5523 18.5523 19 18 19H16V21.0001H18C19.6569 21.0001 21 19.6569 21 18.0001V16H19Z",
    fill: "#7B61FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19V21.0001H6C4.34315 21.0001 3 19.6569 3 18.0001V16H5V18C5 18.5523 5.44772 19 6 19H8Z",
    fill: "#7B61FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11L3 11V13L21 13V11Z",
    fill: "#7B61FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.f2d7a7d19260877aa1a92f7dce274f12.svg";
export { ForwardRef as ReactComponent };